export const GET_HELP_MESSAGE = 'GET_HELP_MESSAGE';

export const getHelpMessage = (data) =>({
    type: GET_HELP_MESSAGE,
    data
});




// WEBPACK FOOTER //
// ./src/views/Help/state/action.js